// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__1ByFu","list":"BalanceDue_list__36z97","listRow":"BalanceDue_listRow__2ZVbr","total":"BalanceDue_total__1A-k-"};